export const getUserAgent = () => window?.navigator?.userAgent;
